document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-blog-subscribe-form').forEach(initForm);
});

function initForm(form) {
	const section = form.closest('.blog-subscribe');
	if (!section) {
		return;
	}
	const emailInput = form.querySelector('input[name="email"]');
	const checkbox = form.querySelector('input[type="checkbox"][required]');
	const submitBtn = form.querySelector('button[type="submit"]');
	const successEl = section.querySelector('.blog-subscribe-success');
	const errorEl = section.querySelector('.blog-subscribe-error');
	const emailError = emailInput
		? form.querySelector('#' + emailInput.id + '-error')
		: null;
	const checkboxError = checkbox
		? form.querySelector('#' + checkbox.id + '-error')
		: null;

	const wrap = form.closest('.blog-subscribe-form-wrap');
	const sectionUrl =
		(wrap && wrap.dataset.thankYouUrl) ||
		(section && section.dataset.thankYouUrl) ||
		'';

	const urlInput = form.querySelector('input[name="url"]');
	const pageNameInput = form.querySelector('input[name="page_name"]');
	if (urlInput) {
		urlInput.value = window.location.href;
	}
	if (pageNameInput) {
		pageNameInput.value = document.title;
	}

	form.addEventListener('submit', async (e) => {
		e.preventDefault();

		const honeypot = form.querySelector('.deque-required-field input');
		if (honeypot && honeypot.value !== '') {
			return;
		}

		clearError(emailInput, emailError);
		clearError(checkbox, checkboxError);
		errorEl.hidden = true;

		let valid = true;
		if (!emailInput.value.trim() || !emailInput.validity.valid) {
			showError(emailInput, emailError, 'Please enter a valid email address.');
			valid = false;
		}
		if (!checkbox.checked) {
			showError(checkbox, checkboxError, 'You must agree to continue.');
			valid = false;
		}
		if (!valid) {
			const firstInvalid = form.querySelector('[aria-invalid="true"]');
			if (firstInvalid) {
				firstInvalid.focus();
			}
			return;
		}

		submitBtn.setAttribute('aria-busy', 'true');
		submitBtn.textContent = 'Submitting\u2026';

		try {
			const data = new URLSearchParams(new FormData(form));
			const ajaxUrl =
				typeof ajax !== 'undefined' && ajax.ajax_url
					? ajax.ajax_url
					: '/wp-admin/admin-ajax.php';
			const response = await fetch(ajaxUrl + '?action=dq_hubspot_form', {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: data.toString(),
			});
			const json = await response.json();

			if (json.success) {
				if (sectionUrl) {
					window.location.assign(sectionUrl);
					return;
				}
				form.hidden = true;
				successEl.innerHTML =
					json.data.message || '<p>Thank you for subscribing!</p>';
				successEl.hidden = false;
				successEl.focus();
			} else {
				const msg =
					json.data && json.data.message
						? json.data.message
						: 'Submission failed';
				throw new Error(msg);
			}
		} catch (err) {
			errorEl.hidden = false;
			errorEl.focus();
			console.error('Blog subscribe error:', err);
		} finally {
			submitBtn.setAttribute('aria-busy', 'false');
			submitBtn.textContent = 'Subscribe';
		}
	});
}

function showError(input, errorEl, message) {
	if (!errorEl) {
		return;
	}
	input.setAttribute('aria-invalid', 'true');
	if (!errorEl.id) {
		errorEl.id = input.id + '-error';
	}
	input.setAttribute('aria-describedby', errorEl.id);
	errorEl.textContent = message;
	errorEl.hidden = false;
}

function clearError(input, errorEl) {
	if (!errorEl) {
		return;
	}
	input.removeAttribute('aria-invalid');
	input.removeAttribute('aria-describedby');
	errorEl.textContent = '';
	errorEl.hidden = true;
}
